/** Lightweight analytics facade: pushes to window.dataLayer / plausible when present, no-op otherwise. */
type Props = Record<string, string | number | boolean>;

export function track(event: string, props: Props = {}) {
  try {
    const w = window as unknown as { dataLayer?: unknown[]; plausible?: (e: string, o?: { props: Props }) => void };
    w.dataLayer?.push({ event, ...props });
    w.plausible?.(event, { props });
    if (import.meta.env.DEV) console.debug("[analytics]", event, props);
  } catch { /* ignore */ }
}
